export default class Activity {
	constructor({
		name,
		description,
		active_form,
		service_time,
		serviforms_form_id,
		resource_id,
		group_id,
		id,
		added_on,
		company_id,
		update_on,
		total_resource,
		total_group,
		dr_points,
	}) {
		this.name = name || "";
		this.description = description || "";
		this.active_form = active_form || 0;
		this.service_time = service_time || "";
		this.serviforms_form_id = serviforms_form_id || "";
		this.resource_id = resource_id || [];
		this.group_id = group_id || [];
		this.id = id || 0;
		this.id = id || 0;
		this.added_on = added_on || "";
		this.company_id = company_id || 0;
		this.update_on = update_on || "";
		this.count_group = this.group_id.length;
		this.count_resource = this.resource_id.length;
		this.total_resource = total_resource || 0;
		this.total_group = total_group || 0;
		this.dr_points = typeof dr_points === "number" ? dr_points : null;
	}
}
